import calcSkillValues from './calcSkillValues'
import collectCharacteristicSkillAdjsUnique from './collectCharacteristicSkillAdjsUnique'
import getSkillFormulaCharacteristics from './getSkillFormulaCharacteristics'
import loadSpecificSkillAdjs from './loadSpecificSkillAdjs'
import store from '../store/index'
//-------------------------
// load skill adjs harness
//-------------------------
export default function loadSkillAdjsHarness(character) {
  console.log('-----------------------')
  console.log('IN loadSkillAdjsHarness')
  //----------------------------------------------------------------------------------------------
  /* create createAdjDetailEntry from the following (+ adj reasons):

  A. character.skills.character_skill_adjs e.g. +10 Stealth [CharacterSkillAdjs]
  B. character.skills.characteristic_skill_adjs e.g. -5 armour dex pen [CharacteristicSkillAdjs]
  C. character.skills.integrated_rune_skill_adjs e.g. +5 Stealth from Shadow Rune [RuneSkillAdjs]

  NB: reasons are stored with the skill object
  NB: totals are already stored on skill object from download
  
  */
  //-----------------------------------------------------------------
  // create empty skill_adjs array for createAdjDetailEntry entries
  //-----------------------------------------------------------------
  character.skill_adjs = []
  //-------------
  // loop skills
  //-------------
  character.skills.forEach((s) => {
    const isParentBasedSkill = !!s.parent_name
    const characteristicNames = isParentBasedSkill ? [] : getSkillFormulaCharacteristics(s)
    s.characteristic_skill_adjs = isParentBasedSkill
      ? []
      : collectCharacteristicSkillAdjsUnique({
          characteristicSkillAdjs: character.characteristic_skill_adjs,
          characteristicNames,
        })

    s.adjs_reasons_character_skill = ''
    s.adjs_reasons_character_skill_opt = ''
    s.adjs_reasons_characteristic_skill = ''
    s.adjs_reasons_integrated_rune_skill = ''

    //--------------------------
    // load specific skill adjs [no need to return updates as mutation done thru reference]
    //--------------------------
    loadSpecificSkillAdjs({ skill: s, character })
    //---------------
    // next skill...
    //---------------
  })

  const config = store.getters['combat/getConfig']
  const max_skill = config ? config.max_skill : 100

  // Rebuild current skill values after adj totals are refreshed so
  // cur/cur_no_adjs stay in sync with the newly loaded skill_adjs.
  character.skills
    .filter((skill) => !skill.parent_name)
    .forEach((skill) => {
      calcSkillValues({ skill, character, max_skill })
    })

  character.skills
    .filter((skill) => !!skill.parent_name)
    .forEach((skill) => {
      calcSkillValues({ skill, character, max_skill })
    })

  return character
}
